import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {LoginManager} from '../_managers/login-manager.services'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private loginManager: LoginManager) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401) {
          // auto logout if 401 response returned from api
         /* this.authenticationService.logout();*/
         this.loginManager.Logout();
          location.reload();
      }

      const error = err.error.message || err.statusText;
      return throwError(error);
  }))
  }
}
